import { useEffect, useState } from 'react'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** API */
import HandInsuranceAPI from 'api/setting/doctor-fee-managements/hand-insurance.api'

/** STYLE */

/** UTILS || SLICE */
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { notiError } from 'component/notifications/notifications'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { numberFormat } from 'utils/app.utils'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  HAND_INSURANCE_HOUR: ``,
  IS_DUPLICATE_HAND_INSURANCE_HOUR: ``,
  HAND_INSURANCE_HOUR_STRING_BASE: ``,
  HAND_INSURANCE_HOUR_STRING_EMPTY: ``,
  HAND_INSURANCE_HOUR_MAXIMUM_LENGTH: ``,
  HAND_INSURANCE_HOUR_ANY_REQUIRED: ``,

  HAND_INSURANCE_PRICE: ``,
  IS_DUPLICATE_HAND_INSURANCE_PRICE: ``,
  HAND_INSURANCE_PRICE_STRING_BASE: ``,
  HAND_INSURANCE_PRICE_STRING_EMPTY: ``,
  HAND_INSURANCE_PRICE_MAXIMUM_LENGTH: ``,
  HAND_INSURANCE_PRICE_ANY_REQUIRED: ``
}
export default function HandInsurance() {
  const { t } = useTranslation()
  const [handInsurances, setHandInsurances] = useState([])
  const [handInsuranceId, setHandInsuranceId] = useState(Number)
  const [hour, setHour] = useState('')
  const [price, setPrice] = useState('')
  const [handInsuranceStatus, setHandInsuranceStatus] = useState('')
  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)

  const loadData = async () => {
    try {
      const resp = await HandInsuranceAPI.findAll({
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setHandInsurances(resp.data)
      } else {
        setHandInsurances([])
      }
    } catch (error) {
      notiError('เกิดข้อผิดพลาด')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const submit = () => {
    setDisabledSubmit(true)
    if (!hour || !price) {
      setDisabledSubmit(false)
      return setErrorMessage({
        ...errorMessage, ...{
          HAND_INSURANCE_HOUR: !hour ? t(`HAND_INSURANCE.MESSAGE.HAND_INSURANCE_HOUR`) : '',
          HAND_INSURANCE_PRICE: !price ? t(`HAND_INSURANCE.MESSAGE.HAND_INSURANCE_PRICE`) : ''
        }
      })
    }
    HandInsuranceAPI.create(hour, price)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          setIsOpenModal(false)
          setIsOpenSnack(true)
          setTypeSnack('success')
          setLabelSnack(t('HAND_INSURANCE.MESSAGE.SUCCESS.CREATE'))
          resetForm()
          loadData()
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`HAND_INSURANCE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`HAND_INSURANCE.MESSAGE.${err.message}`) } })
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    if (!hour || !price) {
      setDisabledSubmit(false)
      return setErrorMessage({
        ...errorMessage, ...{
          HAND_INSURANCE_HOUR: !hour ? t(`HAND_INSURANCE.MESSAGE.HAND_INSURANCE_HOUR`) : '',
          HAND_INSURANCE_PRICE: !price ? t(`HAND_INSURANCE.MESSAGE.HAND_INSURANCE_PRICE`) : ''
        }
      })
    }

    HandInsuranceAPI.update(handInsuranceId, hour, price, handInsuranceStatus)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          setIsOpenModal(false)
          setIsOpenSnack(true)
          setTypeSnack('success')
          setLabelSnack(t('HAND_INSURANCE.MESSAGE.SUCCESS.UPDATE'))
          resetForm()
          loadData()
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`HAND_INSURANCE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`HAND_INSURANCE.MESSAGE.${err.message}`) } })
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setHandInsuranceId(0)
    setHour('')
    setPrice('')
    setHandInsuranceStatus('')

    clearErrorMessage()
  }
  const onActive = () => {
    if (id) {
      HandInsuranceAPI.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('HAND_INSURANCE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('HAND_INSURANCE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      HandInsuranceAPI.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('HAND_INSURANCE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('HAND_INSURANCE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { handInsuranceId: handInsId, hour: handInsHour, price: handInsPrice, status: handInsStatus } = data
    setHandInsuranceId(handInsId)
    setHour(handInsHour)
    setPrice(handInsPrice)
    setHandInsuranceStatus(handInsStatus)
    clearErrorMessage()
    setIsOpenModal(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }

  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }

  const numberOnlyNoDot = (e: any) => {
    const value = e.target.value;
    return value.replace(/[^0-9]/g, '');
  };

  const headCells = [
    { id: 'no', disablePadding: false, label: '#', width: '80px' },
    { id: 'hour', disablePadding: false, label: t('HAND_INSURANCE.TABLE.CELL.HOUR'), align: 'center', class: 'text-nowrap' },
    { id: 'price', disablePadding: false, label: t('HAND_INSURANCE.TABLE.CELL.PRICE'), class: 'text-nowrap' },
    { id: 'status', disablePadding: false, label: t('HAND_INSURANCE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('HAND_INSURANCE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action', width: '100px' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { handInsuranceId: handInsId, hour: handInsHour, price: handInsPrice, updatedBy, updatedAt, status: handInsStatus } = objData

    const statusBtnActive = handInsStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = handInsStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled

    const objRenderData = {
      key: handInsId,
      id: handInsId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'center', label: handInsHour },
        { option: 'TEXT', align: 'right', label: numberFormat(handInsPrice) },
        { option: 'STATUS', align: 'center', label: handInsStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },

        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(obj.handInsuranceId)
    setIsOpenAlertModal(true)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`HAND_INSURANCE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`HAND_INSURANCE.ALERT.${statusAlertModal === "DELETE" ? 'CONFIRM_DELETE' : 'CONFIRM_STATUS'}`, { status: t(`HAND_INSURANCE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        handleClose={() => setIsOpenModal(false)}
        isOpen={isOpenModal}
        title={handInsuranceId ? t('HAND_INSURANCE.TITLE_UPDATE') : t('HAND_INSURANCE.TITLE_CREATE')}
        size='XS'
        onCancel={{ onClick: () => setIsOpenModal(false) }}
        onSubmit={{
          onClick: () => {
            handInsuranceId ? submitEdit() : submit()
          }, disabled: disabledSubmit
        }}
      >
        <Box marginTop="16px">
          {handInsuranceId !== 0 && <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="16px">
            <Typography fontSize="16px" fontWeight={400}>สถานะการใช้งาน</Typography>
            <SwitchButton checked={handInsuranceStatus === 'ACTIVE' ? true : false} onChange={(e) => setHandInsuranceStatus(handInsuranceStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} />
          </Box>}
          <Box display="flex" flexDirection="column" gap="16px">
            <TextInput
              onChange={(event) => {
                setHour(numberOnlyNoDot(event))
                clearErrorMessage()
              }}
              value={hour}
              label={t('HAND_INSURANCE.INPUT.HAND_INSURANCE_HOUR')}
              fullWidth
              helperText={
                errorMessage.HAND_INSURANCE_HOUR ||
                errorMessage.IS_DUPLICATE_HAND_INSURANCE_HOUR ||
                errorMessage.HAND_INSURANCE_HOUR_STRING_BASE ||
                errorMessage.HAND_INSURANCE_HOUR_STRING_EMPTY ||
                errorMessage.HAND_INSURANCE_HOUR_MAXIMUM_LENGTH ||
                errorMessage.HAND_INSURANCE_HOUR_ANY_REQUIRED
              }
              required
              inputProps={{ value: hour }}
            />
            <TextInput
              onChange={(event) => {
                setPrice(numberOnlyNoDot(event))
                clearErrorMessage()
              }}
              helperText={
                errorMessage.HAND_INSURANCE_PRICE ||
                errorMessage.IS_DUPLICATE_HAND_INSURANCE_PRICE ||
                errorMessage.HAND_INSURANCE_PRICE_STRING_BASE ||
                errorMessage.HAND_INSURANCE_PRICE_STRING_EMPTY ||
                errorMessage.HAND_INSURANCE_PRICE_MAXIMUM_LENGTH ||
                errorMessage.HAND_INSURANCE_PRICE_ANY_REQUIRED
              }
              label={t('HAND_INSURANCE.INPUT.HAND_INSURANCE_PRICE')}
              required
              fullWidth
              inputProps={{ value: price }}
            />
          </Box>
        </Box>
      </PageModal>
      <HeaderCard text={t('HAND_INSURANCE.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('HAND_INSURANCE.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />
              <MainButton title={t('HAND_INSURANCE.BUTTON.ADD')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => {
                clearErrorMessage()
                resetForm()
                setIsOpenModal(true)
              }} startIcon={<AddCircleIcon />} />
            </Box>
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={handInsurances.map((val, i) => {
              return renderData(val, i)
            })}
            tableFixedWidth
          />
        </Box>
      </Box>
    </Box>
  )
}
